<h1 class="center">
    Paramètres DAV
</h1>
<nav>
    <a routerLinkActive="active-link" routerLink="./list">Liste</a>
    <a routerLinkActive="active-link" routerLink="./create" hideIfNot="ROLE_ADMIN_GLOBAL">Création</a>
</nav>
<router-outlet></router-outlet>